var SitePage = require('../views/masters/SitePage');
var $ = require('jquery');

/**
 * Especials
 * @constructor
 * @description represent Home Page
 * @extends SitePage
 * @param {Object} options - object contain any attributes
 */

function Especials(options){
    SitePage.call(this);
    this.options = options;
}

Especials.prototype = $.extend(Object.create(SitePage.prototype), {

  constructor: Especials,

  /**
   * Executes when document DOM Tree is ready.
   */
  ready: function() {
    console.log("Ready: Especials");
    SitePage.prototype.ready.call(this);
  },

  /**
   * Executes when the window is fully loaded.
   */
  load: function(){
    console.log("Load: Especials");
  }

});

// Create a instace of this page;
new Especials({ data: {} });
